<form
  class="g-3 needs-validation"
  novalidate
  [formGroup]="formFields"
  (ngSubmit)="onSubmit()"
>
    <div formArrayName="vehicles">

        <mat-panel-title>
          <h4>
            <u>
              <span *ngIf="!vehicles.get('registration_number').value"
                >Horsebox</span
              >
              <span *ngIf="vehicles.get('registration_number').value">{{
                vehicles.get("registration_number").value
              }}</span>
              <span *ngIf="vehicles.get('make').value">
                - {{ vehicles.get("make").value }}</span
              >
              <span *ngIf="vehicles.get('model').value">
                - {{ vehicles.get("model").value }}</span
              >
            </u>
          </h4>
        </mat-panel-title>

      <div class="cal_body">
        <h6 class="text-white">Vehicle Details</h6>
        <div class="row">
          <div class="col-md-6 mb-3">
            <!-- <div class="input-group mb-3"> -->
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Registration Number"
              required
              name="registration_number"
              formControlName="registration_number"
              (change)="onRegistrationNumberChange($event)"
              (keydown.enter)="$event.preventDefault()"
              [ngClass]="{
                'is-invalid':
                  (vehicles.get('registration_number').touched || submitted) &&
                  vehicles.get('registration_number').errors?.required
              }"
            />
            <!-- <span class="input-group-text text-white dark-green-bg pt-0 pb-0">Search</span> -->
            <!-- </div> -->
            <div
              class="invalid-feedback"
              *ngIf="
                (vehicles.get('registration_number').touched || submitted) &&
                vehicles.get('registration_number').errors?.required
              "
            >
              Registration number is required.
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Make"
                required
                name="make"
                formControlName="make"
                [ngClass]="{
                  'is-invalid':
                    (vehicles.get('make').touched || submitted) &&
                    vehicles.get('make').errors?.required
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (vehicles.get('make').touched || submitted) &&
                  vehicles.get('make').errors?.required
                "
              >
                Make is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Model"
              required
              name="model"
              formControlName="model"
              [ngClass]="{
                'is-invalid':
                  (vehicles.get('model').touched || submitted) &&
                  vehicles.get('model').errors?.required
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                (vehicles.get('model').touched || submitted) &&
                vehicles.get('model').errors?.required
              "
            >
              Model is required.
            </div>
          </div>
          <div class="col-md-6">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Year of Make"
              required
              name="year"
              formControlName="year"
              [ngClass]="{
                'is-invalid':
                  (vehicles.get('year').touched || submitted) &&
                  vehicles.get('year').errors?.required
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                (vehicles.get('year').touched || submitted) &&
                vehicles.get('year').errors?.required
              "
            >
              Year is required.
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <mat-form-field class="w-100">
              <mat-label>Gross Vehicle weight</mat-label>
              <!-- Mat select -->
              <mat-select
                required
                formControlName="weight"
                class="form-control form-control-sm"
                name="weight"
                [ngClass]="{
                  'is-invalid':
                    (vehicles.get('weight').touched || submitted) &&
                    vehicles.get('weight').errors?.required
                }"
              >
                <!-- Mat select option -->
                <mat-option
                  *ngFor="let vw of grossWeightOptions"
                  [value]="vw"
                >
                  {{ vw }}
                </mat-option>
              </mat-select>

              <!-- Error Message -->
              <div
                class="invalid-feedback"
                *ngIf="
                  (vehicles.get('weight').touched || submitted) &&
                  vehicles.get('weight').errors?.required
                "
              >
                Please select an option.
              </div>
            </mat-form-field>
          </div>
        </div>

        <!-- Section -->
        <div class="row mt-3">
          <div class="col-md-6">
            <div class="mt-4">
              <h6 class="text-white">
                Please confirm the postcode of where the horsebox is usually
                kept
              </h6>
              <!-- Postcode -->
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Postcode"
                required
                name="kept_at_postcode"
                formControlName="kept_at_postcode"
                [ngClass]="{
                  'is-invalid':
                    (vehicles.get('kept_at_postcode').touched || submitted) &&
                    vehicles.get('kept_at_postcode').errors?.required
                }"
              />
              <!-- Error -->
              <div
                class="invalid-feedback"
                *ngIf="
                  (vehicles.get('kept_at_postcode').touched || submitted) &&
                  vehicles.get('kept_at_postcode').errors?.required
                "
              >
                Postcode is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Proceed button -->
  <div class="row">
    <div class="col-md-12 text-right">
      <button class="btn btn-success btn-sm">Proceed</button>
    </div>
  </div>
</form>

<ng-template #content let-modal>
  <div class="modal-body">
    <div class="helptext" [innerHTML]="helptext"></div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default btn-gray"
      (click)="modal.close()"
    >
      Close
    </button>
  </div>
</ng-template>

<!-- Add driver -->
<!-- <ng-template #drivers let-modal>
  <div class="modal-header">Add New Driver</div>
  <div class="modal-body">
    <div *ngIf="validationMsgForPopUp" class="alert alert-danger">
      {{ validationMsgForPopUp }}
    </div>
    <div class="row">
      <div class="col-md-2">Name</div>
      <div class="col-md-10">
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label class="text-secondary">Title</mat-label>
              <mat-select
                class="form-control form-control-sm"
                name="driver_title"
                [(ngModel)]="driver_title"
                [disabled]="dont_have_driver_name"
              >
                <mat-option
                  *ngFor="let dt of staticData.title_options"
                  [value]="dt"
                >
                  {{ dt }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="text"
                name="driver_forename"
                placeholder="Forename"
                [readonly]="dont_have_driver_name"
                [(ngModel)]="driver_forename"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="text"
                name="driver_surname"
                placeholder="Surname"
                [(ngModel)]="driver_surname"
                class="form-control form-control-sm"
                [readonly]="dont_have_driver_name"
              />
            </div>
          </div>
        </div>

        <div class="form-group vehicles">
          <mat-checkbox
            name="dont_have_driver_name"
            (change)="onNoDriverNameChange($event)"
            value="1"
          >
            Don't have driver name yet
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default btn-gray"
      (click)="modal.close()"
    >
      Close
    </button>
    <button type="button" class="btn btn-success" (click)="createNewDriver()">
      Create Driver
    </button>
  </div>
</ng-template> -->
